const BY_ID: Record<string, string> = {
  confirm_yes: 'chatWidget.confirmWriteYes',
  confirm_edit: 'chatWidget.confirmWriteEdit',
  confirm_abort: 'chatWidget.confirmWriteAbort',
};

const BY_LABEL: Record<string, string> = {
  'Oui, confirme': 'chatWidget.confirmWriteYes',
  Modifier: 'chatWidget.confirmWriteEdit',
  Annuler: 'chatWidget.confirmWriteAbort',
};

/** Write-confirm pills stay FR on the wire; show them in the UI locale. */
export function localizeLaikaActionLabel(
  action: { id?: string; label?: string },
  t: (key: string) => string,
): string {
  const key = (action.id && BY_ID[action.id]) || (action.label && BY_LABEL[action.label]);
  if (key) return t(key);
  return action.label || '';
}
